import React, { Component } from 'react';
import { connect } from 'formik';
import Input from '../../../../components/input/text/input-formik';
import { ISurveyActivityAddProps, IOuterProps, IFormikProps } from '../../../../models/components/add-activity-survey-content';
import { Quil } from '../../../../components/input/quil/main';
import { ActivityCompletionType } from '../../../../models/enums/activityCompletionType';
import { Log } from 'ng2-logger';
import Translator from '../../../../core/i18n';
import { Common } from '../../../../core/common';
import { ActivityTiming } from '../../../../components/add-activity/timing';
import { DatetimeFormik } from '../../../../components/input/date-time/date-time-formik';
import Tooltip from '../../../../components/tooltip/main';

const T = Translator.create();
const _logger = Log.create('profile-tabpanel');
let _common: Common;

export class SurveyActivityContent extends Component<IFormikProps, any> {
    constructor(props: any) {
        super(props);
        _common = new Common();
    }

    public render() {
        return (
            <div
                className={'tab-pane fade' + (this.props.currentTab === '_contentTab' ? ' show active' : '')}
                style={{ display: this.props.currentTab === '_contentTab' ? 'block' : 'none' }}
                id="survey-setting"
                role="tabpanel"
                aria-labelledby="forum-setting-tab"
            >
                <h5 className="mb-0">{T.t('r_activity_search_placeholder')}<span className="ml-1" style={{ color: '#dc5050' }}>*</span></h5>
                <Input type={'text'} name={'name'} placeHolder={T.t('r_activity_search_placeholder')} formik={this.props.formik} />
                <p className="half-color">{T.t('r_activity_list_shown_text')}</p>
                <h5 className="mt-4 mb-2">{T.t('r_description')}</h5>
                <Quil
                    modules={'basic'}
                    placeholder={T.t('r_write_description_for_activity')}
                    /* tslint:disable */
                    onChange={(e: any) => this.props.formik.setFieldValue('description', e)}
                    value={this.props.formik.values.description}
                    theme={'snow'}
                />
                {!this.props.isProjectSubActivity && (
                    <>
                        <ActivityTiming
                            coursePageActivityId={this.props.coursePageActivityId}
                            coursePageClassId={this.props.coursePageClassId}
                            dateFormat={this.props.dateFormat}
                            formik={this.props.formik}
                            isUpdate={this.props.isUpdate}
                            isWeekly={this.props.isWeekly}
                             termType={this.props.termType ?? T.t('r_time_week')}
                             activityType={this.props.activityType}

                        />

                        <div className='d-flex align-items-center'>
                            <h5 className="mt-4 mt-0">{T.t('r_activity_finish_criteria')}</h5>
                            <Tooltip data={T.t('r_activity_finish_criteria_info')} position='top'>
                                <img src={_common.GetDefaultIcons('info')} style={{ width: '1.25em', marginInlineStart: "20px"  }} alt="" />
                            </Tooltip>
                        </div>
                        {this.props && this.props.isUpdate != "" ?
                            <div className="row">
                                {this.props.formik.values.completionType === ActivityCompletionType.Complete ?
                                    <div className="col-md-4">
                                        <div className="radio-tabs tick-radio position-relative">
                                            <input
                                                type="radio"
                                                name={'completionType'}
                                                value={ActivityCompletionType.Complete}
                                                onChange={this.props.formik.setFieldValue.bind(this, 'completionType', ActivityCompletionType.Complete)}
                                                id="completion-type-complete"
                                                className="form-radio"
                                                checked={this.props.formik.values.completionType === ActivityCompletionType.Complete}
                                            />
                                            <label htmlFor="completion-type-complete">{T.t('r_criteria_complete')}</label>
                                        </div>
                                    </div>
                                    : null}
                            </div>
                            :
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="radio-tabs tick-radio position-relative">
                                        <input
                                            type="radio"
                                            name={'completionType'}
                                            value={ActivityCompletionType.Complete}
                                            onChange={this.props.formik.setFieldValue.bind(this, 'completionType', ActivityCompletionType.Complete)}
                                            id="completion-type-complete"
                                            className="form-radio"
                                            checked={this.props.formik.values.completionType === ActivityCompletionType.Complete}
                                        />
                                        <label htmlFor="completion-type-complete">{T.t('r_criteria_complete')}</label>
                                    </div>
                                </div>
                            </div>
                        }
                    </>
                )}

                <h5 className="mt-4 mt-0">{T.t('r_activity_deadline_criteria')}</h5>
                <div className="d-md-flex align-items-md-end delivery-date mt-0">
                    <div className="row mt-0" id="document_end_date">
                        <div className="col-md-6">
                            <div className="form-input form-group date-picker mb-md-0">
                                <DatetimeFormik
                                    name={'taskDeadline'}
                                    dateFormat={this.props.dateFormat}
                                    formik={this.props.formik}
                                    placeHolder={T.t('r_datetime_picker_date')}
                                    datePickerId={'addActivityDate'}
                                    mode="single"
                                    isTouchedOnDidMount={true}
                                    dataClearable={true}
                                    static={true}
                                    activityType={this.props.activityType}
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-input form-group date-picker mb-md-0 ml-md-4 mr-md-4">
                                <DatetimeFormik
                                    name={'taskDeadlinetime'}
                                    formik={this.props.formik}
                                    datePickerId={'addActivityTime'}
                                    placeHolder={T.t('r_time')}
                                    mode="time"
                                    time24Hr={true}
                                    dataClearable={true}
                                    static={true}
                                    activityType={this.props.activityType}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect<ISurveyActivityAddProps, IOuterProps>(SurveyActivityContent);
